import { getImmediateDataFromRealTime } from './services'
import { useConexaQuery } from '@/hooks/useConexaQuery'
import { useAttendanceCallStore } from './store/useAttendanceCall'

export const useGetImmediateAttendance = hasFirebaseStatus => {
  const setAttendanceCall = useAttendanceCallStore(
    store => store.setAttendanceCall,
  )

  return useConexaQuery({
    queryKey: ['immediate-attendance-from-firebase'],
    service: () => getImmediateDataFromRealTime(),
    config: {
      refetchOnWindowFocus: false,
      enabled: !!hasFirebaseStatus,
      onSuccess: data => {
        setAttendanceCall(data?.call)
      },
    },
  })
}
